export default __webpack_public_path__ + "static/media/beauty.e75f19cf.svg";